import { Colors } from "@blueprintjs/core";
import styled from "@emotion/styled";
import Select from "react-select";

import { Box, Flex } from "@/components/layout/flexbox";
import { TimeSlotItemStyled } from "@/components/pieces/schedule/SelectTimeSession/TimeSlotSelector";
import { SUBTEXT_COLOR } from "@/css/constants";

const SelectBox = styled(Box)`
  min-width: 120px;
  border-radius: 6px;
  border: none;
  color: ${Colors.BLACK};
  margin-top: 10px;

  .select-time-range {
    [class$="-control"] {
      border: none;
      border-radius: 6px;
      background-color: ${Colors.LIGHT_GRAY5};
      padding: 9px 4px;
    }

    &.select-time-range-mini {
      [class$="-control"] {
        padding: 4px;
      }
    }
  }
`;

export default function ProductSelector({
  value,
  onChange,
  loading = false,
  disabled = false,
  displayType = "dropdown",
  className = "select-time-range",
  defaultOptions = null,
}) {
  const options = defaultOptions
    ? defaultOptions
    : [25, 50].map((option) => ({
        value: option,
        label: `${option} minute meeting`,
        description: "",
      }));

  if (displayType === "text") {
    return (
      <Flex mt={3}>
        {options.map((item) => (
          <Box key={`${item.value}`}>
            <Box>{item.label}</Box>
            <Box color={SUBTEXT_COLOR}>{item.description}</Box>
          </Box>
        ))}
      </Flex>
    );
  }

  if (displayType === "list") {
    return (
      <Flex mt={2} flexWrap={"wrap"}>
        {options.map((item) => (
          <TimeSlotItemStyled
            css={{
              flex: "1 49%",
              marginRight: "1%",
              maxWidth: "49%",
              fontSize: "14px !important",
            }}
            onClick={() => onChange(item)}
            selected={value === item.value}
            key={`${item.value}`}
          >
            {item.label}
          </TimeSlotItemStyled>
        ))}
      </Flex>
    );
  }

  return (
    <SelectBox>
      <Select
        isDisabled={disabled}
        className={className}
        isLoading={loading}
        value={options.find((option) => option.value == value)}
        onChange={onChange}
        isSearchable={true}
        name="timeZone"
        options={options}
      />
    </SelectBox>
  );
}
